const blocks = document.querySelectorAll(
  ".wp-block-adspire-ai-testimonials-slider"
);

if (blocks.length) {
  import("./view-frontend.js").then(({ initBlock }) => {
    blocks.forEach((block) => initBlock(block));
  });
}
